import IAdminRepository from '../../2_domain/admin/iAdminRepository';
import IClientRepository from '../../2_domain/client/iClientRepository';
import IClinicRepository from '../../2_domain/clinic/iClinicRepository';
import IContactRepository from '../../2_domain/intro/iContactRepository';
import INotificationRepository from '../../2_domain/notification/iNotificationRepository';
import ISLXRepository from '../../2_domain/slx/iSLXRepository';
import IStaffRepository from '../../2_domain/staff/iStaffRepository';
import ISupportRepository from '../../2_domain/support/iSupportRepository';
import ITestRepository from '../../2_domain/test/iTestRepository';
import IUserRepository from '../../2_domain/user/iUserRepository';
import Get from '../../lib/di/get';
import AdminRepository from '../admin/adminRepository';
import ClientRepository from '../client/clientRepository';
import ClinicRepository from '../clinic/clinicRepository';
import ContactRepository from '../intro/contactRepository';
import NotificationRepository from '../notification/notificationRepository';
import SLXRepository from '../slx/SLXRepository';
import StaffRepository from '../staff/staffRepository';
import SupportRepository from '../support/supportRepository';
import TestRepository from '../test/testRepository';
import UserRepository from '../user/userRepository';
import Connection from './connection';

const dependencyInject = () => {
  ///
  Get.put<Connection>('Connection', new Connection());

  /// Repo
  Get.put<IUserRepository>('IUserRepository', new UserRepository());
  Get.put<IClientRepository>('IClientRepository', new ClientRepository());
  Get.put<ISupportRepository>('ISupportRepository', new SupportRepository());
  Get.put<IClinicRepository>('IClinicRepository', new ClinicRepository());
  Get.put<IStaffRepository>('IStaffRepository', new StaffRepository());
  Get.put<ITestRepository>('ITestRepository', new TestRepository());
  Get.put<ISLXRepository>('ISLXRepository', new SLXRepository());
  Get.put<INotificationRepository>(
    'INotificationRepository',
    new NotificationRepository()
  );
  Get.put<IContactRepository>('IContactRepository', new ContactRepository());
  /// temp ... admin
  Get.put<IAdminRepository>('IAdminRepository', new AdminRepository());
};

export default dependencyInject;
